/**
 * DaisyUI theme colors for avatar backgrounds.
 * Selected to provide good contrast with white text.
 */
const COLORS = [
  'bg-primary',
  'bg-secondary',
  'bg-accent',
  'bg-info',
  'bg-success',
  'bg-warning',
  'bg-error',
  'bg-neutral',
] as const;

/**
 * Generates a consistent color from an ID.
 * The same ID will always produce the same color.
 * Uses a simple hash function to map IDs to the color palette.
 */
export default function avatarColor(id: string | null | undefined): string {
  if (!id) return 'bg-neutral';

  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = (hash << 5) - hash + id.charCodeAt(i);
    hash |= 0; // Convert to 32-bit integer
  }

  const index = Math.abs(hash) % COLORS.length;
  return COLORS[index] ?? 'bg-neutral';
}
